import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { Contest } from './contest';
import { ContestService } from './contest.service';
import { Title } from "@angular/platform-browser";
import { ContestAttemptService } from '../service/contest-attempt.service';
import { ContestAttemptDto } from '../models/contest-attempt-dto';
import { firstValueFrom } from 'rxjs';


@Component({
    selector: 'contest',
    templateUrl: './contest.component.html',
    styleUrls: ['./contest.component.scss'],
    standalone: false
})

export class ContestComponent {
    @Input() showEntry!: boolean;
    urlPath!: string;
    gl!: string; // Google Analytics query param
    contestData!: Contest;
    displayDescription: boolean = false;
    contestOver: boolean = false;
    contestRunning: boolean = false;
    questionsComplete: boolean = false;
    contestAttemptDto: ContestAttemptDto | null = null;

    constructor(private router: Router,
        private route: ActivatedRoute,
        public contestService: ContestService,
        private titleService: Title,
        private contestAttemptService: ContestAttemptService
    ) { }

    ngOnInit() {
        this.urlPath = this.route.snapshot.params['urlPath'];
        this.gl = this.route.snapshot.queryParams['_gl']; // from query params
        this.setData();
    }

    onDoneQuestions() {
        this.questionsComplete = true;
        this.router.navigate([this.urlPath, 'entry'], {
            queryParams: { _gl: this.gl },
        });
    }

    onOutletLoaded(entry: { contestId: number; hasLocations: boolean; contestMessage: string;  contestAttemptId: number }) {
        entry.contestId = this.contestData.contestId;
        entry.hasLocations = this.contestData.hasStoreLocations;
        entry.contestMessage = this.contestData.contestMessage;
        entry.contestAttemptId = this.contestAttemptDto?.contestAttemptId ?? 0;
    }

    async setData(): Promise<void> {
        try {
            const data = await firstValueFrom(this.contestService.getContest(this.urlPath));
            this.contestData = data;

            const now = new Date();
            const start = new Date(this.contestData.startDate);
            const end = new Date(this.contestData.endDate);

            if (start <= now && now <= end) {
                this.contestRunning = true;
            } else if (now <= start) {
                this.displayDescription = true;
            } else {
                this.contestOver = true;
            }

            this.titleService.setTitle(this.contestData.contestName);
            const bodyImageURL = `url('${this.contestData.backgroundImageUrl}')`;
            document.body.style.setProperty('--body-bg-image', bodyImageURL);

            // Only start attempt while running (optional)
            if (this.contestRunning) {
                const attempt = await firstValueFrom(
                    this.contestAttemptService.startContestAttempt(this.contestData.contestId)
                );
                this.contestAttemptDto = attempt;
            }
        } catch (err) {
        }
    }

}
